import React from "react";

const VimeoIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.993 4.41084C15.9162 5.97295 14.8283 8.1072 12.7291 10.82C10.5532 13.655 8.71009 15.0692 7.20614 15.0692C6.27818 15.0692 5.48461 14.2078 4.83823 12.4785L3.55187 7.72149C3.07189 5.99224 2.55991 5.13083 2.00953 5.13083C1.88793 5.13083 1.47195 5.38154 0.755173 5.88938L0 4.91226C0.787172 4.22441 1.56154 3.53014 2.32952 2.82944C3.38548 1.9166 4.17265 1.43447 4.69743 1.38947C5.93899 1.26733 6.70696 2.11588 6.99495 3.94156C7.30214 5.90867 7.51973 7.1365 7.63493 7.61864C7.99332 9.24504 8.3901 10.0615 8.81889 10.0615C9.15168 10.0615 9.65726 9.53432 10.3228 8.48005C10.9948 7.42578 11.3532 6.62223 11.398 6.06938C11.494 5.15654 11.1356 4.70012 10.3228 4.70012C9.94525 4.70012 9.54846 4.78369 9.14528 4.95083C9.93245 2.37945 11.4364 1.13233 13.6571 1.20304C15.3083 1.25447 16.0826 2.32159 15.993 4.41084Z",
  fill: "#1AB7EA"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(VimeoIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;